import base from '@/http/url_base';

export default {
  TACHE: base.API_CRM + '/taches',
  NOTE: base.API_CRM + '/tache-notes',
  COMPTE_RENDU: base.API_CRM + '/tache-compte-rendus',
  REQUIREMENTS: base.API_CRM + '/taches/requirements',
  TACHE_START: '/start',
  TACHE_PAUSE: '/pause/',
  TACHE_CONTINUE: '/continue',
  TACHE_FINISH: '/finish',
  TACHE_RESET: '/reset',
  TACHE_RATE: '/rate',
};
